<template>
    <PromoLayout>
        <div class="home">
            <div
                class="home__fixed-photo"
                :style="{
                    backgroundImage: 'url(/images/promo/bg.jpg)',
                }"
            ></div>
            <div
                class="home__fixed-photo mobile"
                :style="{
                    backgroundImage: 'url(/images/promo/mobile-bg.jpg)',
                }"
            ></div>
            <div class="home__hero">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-lg-6">
                            <h1 class="title">
                                {{ $t("promo.Get a free quote in") }}<br />
                                <span class="d-none d-lg-inline">{{
                                    $t("promo.exactly")
                                }}</span>
                                <strong class="ml-4">
                                    {{ $t("promo.30 seconds") }}
                                    <img
                                        src="/images/promo/curved_underline.svg"
                                        alt=""
                                    />
                                </strong>
                            </h1>
                            <div class="home__hero-list">
                                <ul>
                                    <li>
                                        <img
                                            src="/images/promo/bullet.svg"
                                            alt=""
                                        />
                                        <span v-html="$t('promo.First bullet')">
                                        </span>
                                    </li>
                                    <li>
                                        <img
                                            src="/images/promo/bullet.svg"
                                            alt=""
                                        />
                                        <span
                                            v-html="$t('promo.Second bullet')"
                                        >
                                        </span>
                                    </li>
                                    <li>
                                        <img
                                            src="/images/promo/bullet.svg"
                                            alt=""
                                        />
                                        <span v-html="$t('promo.Third bullet')">
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <quoteStepOne />
                            <div
                                class="home__hero-partners d-flex align-items-center justify-content-around justify-content-md-between justify-content-md-between"
                            >
                                <img
                                    srcset="/images/promo/solar_watt/2x.png 2x"
                                    src="/images/promo/solar_watt/1x.png"
                                    width="140"
                                    height="35"
                                    alt=""
                                />
                                <img
                                    srcset="/images/promo/google/2x.png 2x"
                                    src="/images/promo/google/1x.png"
                                    width="140"
                                    height="35"
                                    alt=""
                                />
                                <img
                                    v-if="locale === 'pl'"
                                    class="d-none d-md-inline-block"
                                    srcset="
                                        /images/promo/premium_partner/pl2x.png 2x
                                    "
                                    src="/images/promo/premium_partner/pl1x.png"
                                    alt=""
                                />
                                <img
                                    v-else
                                    class="d-none d-md-inline-block"
                                    srcset="
                                        /images/promo/premium_partner/be2x.png 2x
                                    "
                                    src="/images/promo/premium_partner/be1x.png"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div class="col-12 col-sm-6"></div>
                    </div>
                </div>
            </div>
            <home-info />
            <home-awards />
            <home-product-details />
            <home-reviews />
        </div>
    </PromoLayout>
</template>

<script>
import PromoLayout from "@/Layouts/Promo";
import QuoteStepOne from "@/Components/Promo/QuoteStepOne";
import HomeInfo from "@/Components/Promo/HomeInfo";
import HomeAwards from "@/Components/Promo/HomeAwards";
import HomeProductDetails from "@/Components/Promo/HomeProductDetails";
import HomeReviews from "@/Components/Promo/HomeReviews";
import { mapGetters } from "vuex";

export default {
    components: {
        PromoLayout,
        QuoteStepOne,
        HomeInfo,
        HomeAwards,
        HomeProductDetails,
        HomeReviews,
    },
    computed: {
        ...mapGetters({
            options: "options",
        }),
        locale() {
            return process.env.MIX_APP_LOCALE || "pl";
        },
    },
};
</script>

<style lang="scss" scoped>
.home {
    position: relative;
    padding-bottom: 60px;

    &__fixed-photo {
        background: #f7f9fc;
        position: fixed;
        right: 0;
        top: 0;
        width: calc(50% - 80px);
        height: 100vh;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        &.mobile {
            display: none;
        }
        @media (max-width: 1024px) {
            &.mobile {
                display: block;
            }
            &:not(.mobile) {
                display: none;
            }
            position: relative;
            height: 50vw;
            width: 100%;
        }
    }
    &__hero {
        padding-top: 30px;
        &-partners {
            padding: 36px 0px 64px;
            img {
                @media (min-width: 1024px) {
                    max-width: 30%;
                }
            }
        }
        &-list {
            margin-bottom: 40px;

            @media (max-width: 700px) {
                margin-bottom: 25px;
            }
            ul {
                list-style: none;
                padding: 0;
                margin: 0;
                li {
                    font-weight: normal;
                    font-size: 16px;
                    line-height: 30px;
                    color: #1b2f51;
                    position: relative;
                    padding-left: 24px;
                    img {
                        position: absolute;
                        left: 0;
                        top: 7px;
                    }
                }
            }
        }
        .title {
            font-weight: 400 !important;
            font-size: 38px;
            color: #2c2c4f;
            margin-bottom: 50px;
            @media (max-width: 1024px) {
                font-weight: normal;
                font-size: 22px;
                color: #2c2c4f;
                margin-bottom: 24px;
                br {
                    display: none;
                }
            }
            strong {
                position: relative;
                img {
                    position: absolute;
                    top: 46px;
                    left: 0;
                    right: 0;
                    max-width: 100%;
                    @media (max-width: 1024px) {
                        top: 24px;
                    }
                }
            }
        }
    }
}
</style>
